export default __webpack_public_path__ + "static/8-aa5873761e01e54baa9754b5524e90cb.webp";